import { render, staticRenderFns } from "./roster-subject-keywords.vue?vue&type=template&id=e55ec960&scoped=true&"
import script from "./roster-subject-keywords.ts?vue&type=script&lang=ts&"
export * from "./roster-subject-keywords.ts?vue&type=script&lang=ts&"
import style0 from "./roster-subject-keywords.scss?vue&type=style&index=0&id=e55ec960&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55ec960",
  null
  
)

export default component.exports